import React from "react";
import { classNames } from "../utils";
import { PlusCircleIcon } from "@heroicons/react/24/outline";

function AddButton({
  text,
  onClick,
  className,
  disabled = false,
  id = undefined,
}: {
  text: string | JSX.Element;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
  disabled?: boolean;
  id?: string;
}) {
  return (
    <button
      id={id ? id : undefined}
      className={classNames(
        "inline-flex justify-center items-center gap-2 text-sm",
        className ?? "",
        disabled ? "opacity-40" : ""
      )}
      onClick={onClick}
      disabled={disabled}
    >
      <PlusCircleIcon className="w-5" />
      {text}
    </button>
  );
}

export default AddButton;
